export const gitHash = () => {
  /* eslint-disable-next-line no-undef */
  return CIRCLE_SHA1
}
